import { imageUrl } from '@/utils/image-url';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Image, Text, View } from 'react-native';

interface AvatarGroupUser {
  id: string;
  avatarUrl?: string | null;
}

interface AvatarGroupProps {
  users: AvatarGroupUser[];
  totalCount: number;
  size?: number;
  overlapPx?: number;
  maxVisible?: number;
}

export function AvatarGroup({
  users,
  totalCount,
  size = 22,
  overlapPx = 8,
  maxVisible = 3,
}: AvatarGroupProps) {
  const visible = users.slice(0, maxVisible);
  const overflow = totalCount - visible.length;
  const borderWidth = 0.5;

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      {visible.map((user, index) => {
        const uri = imageUrl(user.avatarUrl, 'thumbnail');
        return (
          <View
            key={user.id}
            style={{
              width: size,
              height: size,
              borderRadius: size / 2,
              marginLeft: index === 0 ? 0 : -overlapPx,
              zIndex: visible.length - index,
              borderWidth,
              overflow: 'hidden',
            }}
            className="bg-surface-secondary border-border-visible"
          >
            {uri ? (
              <Image
                source={{ uri }}
                style={{
                  width: size - borderWidth * 2,
                  height: size - borderWidth * 2,
                  borderRadius: (size - borderWidth * 2) / 2,
                }}
              />
            ) : (
              <View
                style={{
                  width: size - borderWidth * 2,
                  height: size - borderWidth * 2,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Ionicons
                  name="person"
                  size={Math.round((size - borderWidth * 2) * 0.55)}
                  className="text-muted-foreground"
                />
              </View>
            )}
          </View>
        );
      })}
      {overflow > 0 && (
        <Text
          className="text-muted-foreground"
          style={{ fontSize: 12, marginLeft: 4 }}
        >
          +{overflow}
        </Text>
      )}
    </View>
  );
}
